import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";

export interface EmptyStateProps {
  icon: IconName;
  title: string;
  body?: string;
  action?: ReactNode;
  tone?: "default" | "danger";
}

export function EmptyState({ icon, title, body, action, tone = "default" }: EmptyStateProps) {
  return (
    <div className="empty" role={tone === "danger" ? "alert" : undefined}>
      <div className="empty-art" style={tone === "danger" ? { background: "var(--c-danger-soft)", color: "var(--c-danger)" } : undefined}>
        <Icon name={icon} />
      </div>
      <h2>{title}</h2>
      {body && <p>{body}</p>}
      {action}
    </div>
  );
}
